import axiosInstance from "./index";

const axios = axiosInstance

export const getfilterTree = (treeData, filterArray) => {
  const requestBody = {
    treeData: treeData,
    filterArray: filterArray
  };
  return axios.post('/t2thubAPI/filtertree', requestBody)}

export const gethomesearch = (gene,species) => {
  const requestBody = {
    gene: gene,
    species: species
}
  return axios.post('/t2thubAPI/homesearch', requestBody)
}

export const getfetchseqchr = (species) => {
  const requestBody = {
    species: species
}
  return axios.post('/t2thubAPI/fetchseqchr', requestBody)
}

export const getseqtk = (seqtkParams) => {
  const requestBody = {
    all: seqtkParams
}
  return axios.post('/t2thubAPI/seqtk', requestBody)
}
export const getmsa = (seq) => {
  const requestBody = {
    seq: seq
}
  return axios.post('/t2thubAPI/msa', requestBody)
}
export const gethometable = () => {return axios.get('/t2thubAPI/genometreeinfo')}
export const getgenomestatic = () => {return axios.get('/t2thubAPI/genomestatic')}

export const gethomeclassify = () => {return axios.get('/t2thubAPI/taxonomy')}

export const gethomolog = (ortho,species) =>{return axios.post('/t2thubAPI/homolog', {"ortho":ortho, "species":species})}

export const getGenome = (species) => {return axios.get('/t2thubAPI/genome?species='+species)}

export const getuploadGenome = (id) => {return axios.get('/t2thubAPI/uploadgenome?id='+id)}

export const getstatusGenome = (taskid) => {return axios.get('/t2thubAPI/task_status?taskid='+taskid)}

export const getNCBIMeta = (species) => {return axios.get('/pgdatabaseAPI/ncbimeta?species='+species)}

export const getGeneDetails = (species, gene) => {return axios.get('/t2thubAPI/gene?species='+species+'&gene='+gene)}

export const getuploadGeneDetails = (id, gene) => {return axios.get('/t2thubAPI/uploadgene?id='+id+'&gene='+gene)}

export const getNavList = () => {return axios.get('/t2thubAPI/navlist')}

export const getDataPortal = () => {return axios.get('/t2thubAPI/dataportal')}

export const getRecentRelease = () => {return axios.get('/t2thubAPI/recentrelease')}

export const getBrowserUrl = (trackHeight, trackName, trackColor) => {
  return axios.post(`pgdatabaseAPI/browser`, 
  {"trackHeight": trackHeight, "trackName": trackName, "trackColor": trackColor})
}

export const centrofinder = (filename,n,m,g,l,email,genomeFileList,gff3FileList,onUploadProgress) => {
  const formData = new FormData();
  const config = {
    headers: {'Content-Type': 'multipart/form-data'},
    onUploadProgress: onUploadProgress // 添加进度回调
  }
  formData.append('filename', filename);
  formData.append('n', n);
  formData.append('m', m);
  formData.append('g', g);
  formData.append('l', l);
  formData.append('email', email);
  formData.append('genome', genomeFileList);
  formData.append('gff3', gff3FileList);
  return axios.post('/t2thubAPI/centrofinder', formData, config)
}
export const telofinder = (filename,type,num,email,genomeFileList,onUploadProgress) => {
  const formData = new FormData();
  const config = {
    headers: {'Content-Type': 'multipart/form-data'},
    onUploadProgress: onUploadProgress // 添加进度回调
  }
  formData.append('filename', filename);
  formData.append('type', type);
  formData.append('num', num);
  formData.append('email', email);
  formData.append('genome', genomeFileList);
  return axios.post('/t2thubAPI/telofinder', formData, config)
}

export const getfimo = (species, motif) => {
  const formData = new FormData();
  const config = {
    headers: {'Content-Type': 'multipart/form-data'}
  }
  formData.append('species', species);
  formData.append('motif', motif);
  return axios.post('/t2thubAPI/fimo', formData, config)
}

export const uploadFiles = (Latinname, Commonname, Cultivarname, email, doi, desc, genomeFileList, gff3FileList, onUploadProgress) => {
  const formData = new FormData();
  const config = {
    headers: {'Content-Type': 'multipart/form-data'},
    onUploadProgress: onUploadProgress // 添加进度回调
  }
  formData.append('Latinname', Latinname);
  formData.append('Commonname', Commonname);
  formData.append('Cultivarname', Cultivarname);
  formData.append('email', email);
  formData.append('doi', doi);
  formData.append('desc', desc);
  formData.append('genome', genomeFileList);
  formData.append('gff3', gff3FileList);
  return axios.post('/t2thubAPI/UserUpload', formData, config)
}

export const upload = (formDataFields, genomeFileList, gff3FileList, repeatgff3FileList, ncRNAgff3FileList, pngFileList, onUploadProgress) => {
  const formData = new FormData();
  const config = {
    headers: {'Content-Type': 'multipart/form-data'},
    onUploadProgress: onUploadProgress // 添加进度回调
  }
  // 动态遍历 formDataFields 对象并将值加入 FormData
  for (const [key, value] of Object.entries(formDataFields)) {
    if (value) {
      formData.append(key, value);
    }
  }

  // 单独处理文件列表
  formData.append('genome', genomeFileList[0]);
  formData.append('gff3', gff3FileList[0]);
  formData.append('repeatgff3', repeatgff3FileList[0]);
  formData.append('ncRNAgff3', ncRNAgff3FileList[0]);
  formData.append('png', pngFileList[0]);
  
  return axios.post('/t2thubAPI/Upload', formData, config)
}

export const getcheckCookie = (identification) => {
  return axios.get('/t2thubAPI/checkcookie', {
    params: {
      identification
    }
  });
};

export const postBlastSeq = (sequence, time, species, program, identification) => {
  let param = new FormData()
  const config = {
    headers: {'Content-Type': 'multipart/form-data'}
  }
  param.append('sequence', sequence)
  param.append('time', time)
  param.append('species', species)
  param.append('program', program)
  param.append('identification', identification)
  return axios.post('/t2thubAPI/blastupload', param, config)
}

export const postBlastParams = (fileName, species, targetType, program, eValue, compMatrix, wordLength, resultNum, allowGap, emailContent, identification) => {
  return axios.post('/t2thubAPI/blastparams', {
    'fileName': fileName,
    'species': species,
    'targetType': targetType,
    'program': program,
    'eValue': eValue,
    'compMatrix': compMatrix,
    'wordLength': wordLength,
    'resultNum': resultNum,
    'allowGap': allowGap,
    'emailContent': emailContent,
    'identification': identification
  }, 
  {
    timeout: 1000*60*60,
  })
}

export const ulpostBlastParams = (fileName, species, targetType, program, eValue, compMatrix, wordLength, resultNum, allowGap, emailContent, identification) => {
  return axios.post('/t2thubAPI/ulblastparams', {
    'fileName': fileName,
    'species': species,
    'targetType': targetType,
    'program': program,
    'eValue': eValue,
    'compMatrix': compMatrix,
    'wordLength': wordLength,
    'resultNum': resultNum,
    'allowGap': allowGap,
    'emailContent': emailContent,
    'identification': identification
  }, 
  {
    timeout: 1000*60*60,
  })
}

export const getBlastResultRec = (taskid, identification) => {
  return axios.get('/t2thubAPI/blastresultrec', {
    params: {
      taskid,
      identification
    },
    timeout: 1000 * 60 * 60
  });
}

export const getBlastHistory = (identification) => {
  return axios.get('/t2thubAPI/blasthistory', {
    params: {
      identification
    }
  });
}

export const deleteBlastHistory = (taskid, identification) => {
  return axios.get('/t2thubAPI/changehistory', {
    params: {
      taskid,
      identification
    }
  });
}

export const getBrowserList = (browser) => {return axios.get('/t2thubAPI/listbrowser?browser='+browser)}

export const getGoEnrichmentList = () => {return axios.get('/t2thubAPI/enrichmentlist')}

export const getGoEnrichment = (type, species, genes,yemian) => {
  if(type === 'file') {
    let param = new FormData()
    const config = {
      headers: {'Content-Type': 'multipart/form-data'}
    }
    param.append('species', species)
    param.append('type', 'file')
    param.append('genes', genes)
    param.append('yemian', yemian)
    return axios.post('/t2thubAPI/enrichment', param, config)
  }else{
    // Use post for large sets
    if(genes.split(';').length>50){
      let param = new FormData()
      const config = {
        headers: {'Content-Type': 'multipart/form-data'}
      }
      param.append('species', species)
      param.append('type', 'input')
      param.append('genes', genes)
      param.append('yemian', yemian)
      return axios.post('/t2thubAPI/enrichment', param, config)
    }else{
      return axios.get('/t2thubAPI/enrichment?species='+species+'&genes='+genes+'&yemian='+yemian)
    }
    
  }
}

export const ulgetGoEnrichment = (type, species, genes,yemian) => {
  if(type === 'file') {
    let param = new FormData()
    const config = {
      headers: {'Content-Type': 'multipart/form-data'}
    }
    param.append('species', species)
    param.append('type', 'file')
    param.append('genes', genes)
    param.append('yemian', yemian)
    return axios.post('/t2thubAPI/ulenrichment', param, config)
  }else{
    // Use post for large sets
    if(genes.split(';').length>50){
      let param = new FormData()
      const config = {
        headers: {'Content-Type': 'multipart/form-data'}
      }
      param.append('species', species)
      param.append('type', 'input')
      param.append('genes', genes)
      param.append('yemian', yemian)
      return axios.post('/t2thubAPI/ulenrichment', param, config)
    }else{
      return axios.get('/t2thubAPI/ulenrichment?species='+species+'&genes='+genes+'&yemian='+yemian)
    }
    
  }
}

export const getIDConversion = (type, species, genes) => {
  if(type === 'file') {
    let param = new FormData()
    const config = {
      headers: {'Content-Type': 'multipart/form-data'}
    }
    param.append('species', species)
    param.append('type', 'file')
    param.append('genes', genes)
    return axios.post('/t2thubAPI/conversion', param, config)
  }else{
    if(genes.split(';').length>50){
      let param = new FormData()
      const config = {
        headers: {'Content-Type': 'multipart/form-data'}
      }
      param.append('species', species)
      param.append('type', 'input')
      param.append('genes', genes)
      return axios.post('/t2thubAPI/conversion', param, config)
    }else{
      return axios.get('/t2thubAPI/conversion?species='+species+'&genes='+genes)
    }
  }
}

export const getSyntenyURL = (source, target) => {return axios.get('/t2thubAPI/synteny?source='+source+'&target='+target)}

export const getSyntenyList = () => {return axios.get('/t2thubAPI/syntenylist')}

export const getPrimerDesign = (species, location, size, gc, tm, prodsize, num) => {
  return axios.get('/t2thubAPI/primerdesign?species='+species+'&location='+location+'&size='+size+
    '&tm='+tm+'&gc='+gc+'&num='+num+'&prodsize='+prodsize)
}

export const getPrimerDesignList = () => {return axios.get('/t2thubAPI/primerlist')}

export const getDownloadList = () => {return axios.get('/t2thubAPI/downloadlist')}

export const getDownloadFile = (fileList) => {
  return axios.post('/t2thubAPI/download', {'files': fileList})
}